import {Cred, Resource} from '.';
import {formatPhoneNum} from '../utils';
import {Aura, ElevatorPitch} from './aura.model';

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  IN_ACTIVE = 'IN_ACTIVE',
  INVITED = 'INVITED',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
}
export class PhoneNumber {
  countryCode: string;
  phoneNumber: string;

  constructor(json: {countryCode?: string; phoneNumber?: string}) {
    this.countryCode = json.countryCode ?? '';
    this.phoneNumber = json.phoneNumber ?? '';
  }
}

export interface AccountUpdatePayload {
  bio?: string;
  email?: string;
  firstName?: string;
  interests?: string[];
  lastName?: string;
  profilePictureResource?: string;
  title?: string;
}

export class Account {
  bio: string;
  displayName: string;
  dittosCount: number;
  email?: string;
  elevatorPitch?: ElevatorPitch;
  elevatorPitchResource?: Resource;
  facebookProfileUrl?: string;
  followersCount?: number;
  famsCount?: number;
  firstName?: string;
  followingsCount: number;
  hasBusiness?: boolean;
  hasBusinessAccount?: boolean;
  id: string;
  instagramProfileUrl?: string;
  interests: string[];
  isFam?: boolean;
  lastName?: string;
  linkedInProfileUrl?: string;
  perksSentCount: number;
  perksReceivedCount: number;
  phoneNumber: PhoneNumber;
  profilePictureResource?: Resource;
  reccosCount: number;
  reccoedBusinessCount: number;
  squadId: string;
  squadMembersCount: number;
  status: AccountStatus;
  token?: string;
  title?: string;
  userName: string;
  isFollowing: boolean;
  isFollower: boolean;

  constructor(json: any) {
    this.bio = json.bio || '';
    this.displayName = json.displayName ? formatPhoneNum('', json.displayName).trim() : '';
    this.dittosCount = json.dittosCount || 0;
    this.email = json.email || '';
    this.elevatorPitch = json.elevatorPitch && new ElevatorPitch(json.elevatorPitch);
    this.elevatorPitchResource = json.elevatorPitchResource && new Resource(json.elevatorPitchResource);
    this.famsCount = json.famMembersCount || 0;
    this.followersCount = json.followersCount || 0;
    this.firstName = json.firstName || '';
    this.followingsCount = json.followingCount || 0;
    this.id = json._id || json.id;
    this.interests = json.interests || [];
    this.isFam = json.isFam || false;
    this.hasBusiness = json.hasBusiness;
    this.hasBusinessAccount = json.hasBusinessAccount;
    this.lastName = json.lastName || '';
    this.perksSentCount = json.perksSentCount || 0;
    this.perksReceivedCount = json.perksReceivedCount || 0;
    this.phoneNumber = json.phoneNumber && new PhoneNumber(json.phoneNumber);
    this.profilePictureResource = json.profilePictureResource && new Resource(json.profilePictureResource);
    this.reccosCount = json.reccosCount || 0;
    this.reccoedBusinessCount = json.reccoedBusinessCount || 0;
    this.squadId = json.squadId;
    this.squadMembersCount = json.squadMembersCount || 0;
    this.status = json.status;
    this.title = json.title;
    this.token = json.token;
    this.userName = Account.getDisplayName(this) || '';
    this.isFollower = json.isFollower;
    this.isFollowing = json.isFollowing;
    this.facebookProfileUrl = json.facebookProfileUrl || '';
    this.instagramProfileUrl = json.instagramProfileUrl || '';
    this.linkedInProfileUrl = json.linkedInProfileUrl || '';
  }

  static getDisplayName(acc: Account, defaultToPhone = true): string {
    if (!acc) {
      return '';
    }
    const name =
      (`${acc.firstName} ${acc.lastName}`.trim() || (acc.displayName?.startsWith('+') ? '' : acc.displayName) || '')
        .replace(/undefined/g, '')
        .replace(/ +/g, ' ')
        .trim() || '';
    return !defaultToPhone ? name : name || `${formatPhoneNum(acc.phoneNumber?.countryCode, acc.phoneNumber?.phoneNumber)}`;
  }
}

export class AuraWithCred {
  aura: Aura;
  cred: Cred;

  constructor(json: any) {
    this.aura = new Aura(json.aura);
    this.cred = new Cred(json.cred);
  }
}
